// Google Ads conversion: "DSIN Purchase - Conversion"
const ADS_PURCHASE_SEND_TO = 'AW-575742636/YmOxCJC_tu4BEKzFxJIC';

/**
 * Fires the purchase conversion once per order.
 * - gtag 'conversion' event -> Google Ads (works without any GTM setup).
 * - dataLayer 'purchase' event -> available to GTM tags/triggers (GA4 etc).
 * transaction_id lets Google Ads de-duplicate if both paths ever report the same order.
 */
export function trackPurchase(order) {
  if (!order?.transactionId) return;

  const firedKey = `conv_fired_${order.transactionId}`;
  try {
    if (sessionStorage.getItem(firedKey)) return; // page refresh / back navigation
    sessionStorage.setItem(firedKey, '1');
  } catch (e) {}

  window.dataLayer = window.dataLayer || [];

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      send_to: ADS_PURCHASE_SEND_TO,
      value: order.value,
      currency: 'INR',
      transaction_id: order.transactionId,
    });
  }

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'purchase',
    ecommerce: {
      transaction_id: order.transactionId,
      value: order.value,
      currency: 'INR',
      payment_type: order.paymentType,
      items: order.items,
    },
  });
}
